<template>
  <base-button mode="btn btn-default btn-xs">
    <template #default> <i class="fa fa-share"></i> Share </template>
  </base-button>
  <base-button mode="btn btn-default btn-xs" @click="likePost(post)">
    <template #default> <i class="fa fa-thumbs-o-up"></i> Like </template>
  </base-button>
</template>
<script>
import { useStore } from "vuex";

export default {
    props: {
        post: {
            type: Object,
            required: true,
        },
    },
    setup() {
        const store = useStore();
        async function likePost(post) {
            await store.dispatch("like/likePost", { postId: post.id });
        }

        return {
            likePost,
        };
    }
}
</script>